<template>
  <tr>
    <td v-for="header in headers" :key="header.text">
      <b v-if="header.value === options.totalCalculate.titleField">{{ fmt(rowData[header.value]) }}</b>
      <template v-else-if="header.value === 'funded_percent'">
        {{ rowData['registration'] === 0 ? 100 : round((rowData['funded'] / rowData['registration']) * 100, 4) }}
      </template>
      <template v-else>{{ fmt(rowData[header.value]) }}</template>
    </td>
  </tr>
</template>

<script>
  import { round } from 'lodash'

  export default {
    props: {
      rowData: Object,
      headers: Array,
      options: Object,
      fmt: {
        type: Function,
        default: v => v,
      },
    },
    methods: {
      round,
    },
  }
</script>
